

export enum SlotType {
  intent = 'intent',
  composite = 'composite',
  entity = 'entity',
  generic = 'generic_type',
  external = 'external_type',
  unknown = ''
}
